import DynamicComponent from ".."

export default function PawprintBackgroundSection({ blok }) {
  return (
    <section className="bg-grayPawprint bg-repeat py-4">
      {blok?.bloks
        ? blok.bloks.map(({ _uid, ...blok }) => (
            <div className="relative mx-auto" key={_uid}>
              <DynamicComponent blok={blok} />
            </div>
          ))
        : null}
    </section>
  )
}
